<template>
  <div class="bg-brand-taupe-500">
    <PageHeader :headingContent="headingContent" />
    <div class="pb-4">
      <div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
        <div>
          <h3 class="text-xl text-brand-blue-400 font-display uppercase justify-center md:justify-start mb-4">
            New Invitations
          </h3>
          <p>
            You can send new invitations to clients using the Invitations page.
          </p>
        </div>
        <Link href="/admin/invitations" class="">
        <button class="
          bg-brand-blue-400
          hover:bg-brand-blue-200
          text-white
          font-bold
          mt-6
          py-2
          px-4
          rounded
          justify-right
          uppercase
        ">
          New Invitations
        </button>
        </Link>
      </div>
      <div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
        <div>
          <h3 class="text-xl text-brand-blue-400 font-display uppercase justify-center md:justify-start mb-4">
            Invitation Reminders
          </h3>
        </div>
        <div class="gap-4">
          <p>
            You can review previously sent invitations and send clients a reminder using the Reminders page .
          </p>
        </div>
        <Link href="/admin/reminders" class="">
        <button class="
          bg-brand-blue-400
          hover:bg-brand-blue-200
          text-white
          font-bold
          mt-6
          py-2
          px-4
          rounded
          justify-right
          uppercase
        ">
          Invitation Reminders
        </button>
        </Link>
      </div>
    </div>
	<div class="px-4">
		<div class="container mx-auto mb-4">
			<div class="gap-4 justify-center md:justify-start">
				<h1 class="text-2xl text-brand-blue-400 font-display text-center md:text-left uppercase">
					Statistics
				</h1>
			</div>
		</div>
	</div>
	<div class="pb-4">
		<div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
			<div class="flex w-full">
				<div class="flex items-center w-1/2">
					<div class="text-xl text-brand-blue-400 font-display uppercase justify-center md:justify-start mr-2">
						Submitted Reviews:
					</div>
					<div class="text-lg font-bold">
						{{ submitted }}
					</div>
				</div>
				<div class="flex items-center w-1/2">
					<div class="text-xl text-brand-blue-400 font-display uppercase justify-center md:justify-start mr-2">
						Reviews in progress:
					</div>
					<div class="text-lg font-bold">
						{{ in_progress }}
					</div>
				</div>
			</div>
        	<Link href="/admin/reviews" class="">
	        	<button class="bg-brand-blue-400 hover:bg-brand-blue-200 text-white font-bold mt-6 py-2 px-4 rounded justify-right uppercase">
	        		View Reviews
        		</button>
        	</Link>
		</div>
	</div>
  </div>
</template>

<script>
import PageHeader from "@/Shared/PageHeader";
import Layout from "@/Shared/Layouts/Admin/Layout";

export default {
    components: {
    PageHeader,
  },
  layout: Layout,
  name: "Admin-Dashboard",
  data: function () {
    return {
      headingContent: {
        hero: {
          image: '/images/254411986_car_hero.jpg',
          title: 'Fleet Risk Review',
          subtitle: 'In association with AXA Insurance',
        },
        page: {
          title: 'Administration',
          subtitle: '',
        },
      }
    }
  },
  props: ['submitted', 'in_progress', ],
};
</script>
